import React from 'react'

import ApplySkeleton from '@core/components/ApplyDialogV2/ApplySkeleton'

import type { PostInfoV2 } from '@page/post-v2/types'
import './PostPageV2About.scss'

interface PostPageV2AboutProps {
    postInfo?: PostInfoV2 | undefined | null
    isLoading?: boolean
}

const baseClass = 'PostPageV2About'

function PostPageV2About({ postInfo, isLoading }: PostPageV2AboutProps) {
    if (isLoading) {
        return (
            <div className={baseClass}>
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'40%'}
                    height={30}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'100%'}
                    height={20}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
            </div>
        )
    }

    if (!postInfo?.data?.company?.description) {
        return null
    }

    return (
        <div className={baseClass}>
            {/*<div className={`${baseClass}__title`}>{decodeHtmlEntitiesRecursive(postInfo?.data?.company?.name)}</div>*/}
            <div
                className={`${baseClass}__body`}
                dangerouslySetInnerHTML={{
                    __html: postInfo?.data?.company?.description ?? '',
                }}
            ></div>
        </div>
    )
}

export default PostPageV2About
